import { useFormik } from "formik"
import React, { useState, useEffect, useCallback } from "react"
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap"
import * as Yup from "yup"
import AsyncSelect from "react-select/async"
import { customStylesSelect } from "common/data/settings"
import { getAuthorizationToken } from "helpers/storagehelper"
import CustomSelectwithLabel from "components/Common/CustomSelectwithLabel"
import DatePicker from "react-datepicker"
import InputMask from "react-input-mask"
import moment from "moment"
import {
  GetAllNonWorkingHours,
  insertupdateNonWorkinghours,
} from "store/CalculateIncentive/action"
import { useDispatch } from "react-redux"
import { taskTotalHoursConversion } from "helpers/util"

const IncentiveForm = props => {
  const { selectedRow, isEdit, handleCancel } = props
  const dispatch = useDispatch()
  const [allUsers, setAllUser] = useState([])
  const [filtersub, setfiltersub] = useState(null)
  const [ids, setids] = useState(null)

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  useEffect(() => {
    getUserListData(authUser.data?.firstname.substr(0, 2), () => {}, undefined)
  }, [])

  const getUserListData = async (
    searchValue,
    callback,
    searchKey = "useremail"
  ) => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUser(res.data)
          return res.data.map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }


  const [selectname, setSelectname] = useState([
    {
      label: "All",
      value: "11",
    },
  ])

  const maincategory = props.MainCategory?.sort(SortArray)

  useEffect(() => {
    const filteredData = ids?.id
      ? props.teams?.filter(el => el?.categoryId === ids?.id)
      : props.teams
    setfiltersub(filteredData)
  }, [ids])

  var mergeMainCategory = maincategory?.map(item => ({
    clientName: item.name,
    id: item.id,
  }))
  
  var mergeSubCategory = filtersub?.map(item => ({
    projectName: item?.name,
    id: item?.id,
    categoryId: item?.categoryId,
  }))

  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }
  useEffect(() => {
    clientFilter()
  }, [selectedRow])

  const clientFilter = value => {
    setids(
      value == null
        ? {
            label: selectedRow.categoryName,
            value: selectedRow.categoryId,
            id: selectedRow.categoryId,
          }
        : value
    )
  }

  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }

  useEffect(() => {
    if (selectname?.label === "All" || selectname == null) {
      getUserListData(
        authUser.data?.firstname.substr(0, 2),
        () => {},
        undefined
      )
    }
  }, [selectname])

  const handleResponse = status => {
    if (status === "SUCCESS") {
      validation.resetForm()
      handleCancel()
      dispatch(GetAllNonWorkingHours())
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: isEdit ? selectedRow?.id : 0,
      comments: isEdit ? selectedRow?.comments : "",
      maximumHours: isEdit ? selectedRow?.maximumHours : "",
      userName: isEdit
        ? { label: selectedRow.userName, value: selectedRow.userId } || ""
        : "",
      startDate: isEdit
        ? moment(selectedRow?.startDate).format("YYYY-MM-DD") ||
          moment().format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
      endDate: isEdit
        ? moment(selectedRow?.endDate).format("YYYY-MM-DD") || null
        : null,
      subcategoryId: isEdit
        ? {
            label: selectedRow.subcategoryName,
            value: selectedRow.subcategoryId,
          } || ""
        : "",
      categoryId: isEdit
        ? { label: selectedRow.categoryName, value: selectedRow.categoryId } ||
          ""
        : "",
    },
    validationSchema: Yup.object().shape({
      comments: Yup.string().required("Please Enter your Comments"),
      maximumHours: Yup.string().required("Please Enter your Maximum Hours"),
      subcategoryId: Yup.object()
        .shape({})
        .nullable()
        .required("Please select a Project"),
      userName: Yup.object()
        .shape({})
        .nullable()
        .required("Please select a User Name"),
      endDate: Yup.date().nullable().required("Please choose End Date"),
    }),
    onSubmit: values => {
      const actionPayload = {
        id: isEdit ? selectedRow?.id : 0,
        userId: values?.userName?.value || values?.userName?.id,
        subcategoryId: parseInt(
          values?.subcategoryId?.value || values?.subcategoryId?.id
        ),
        endDate: moment(values?.endDate).format("YYYY-MM-DD"),
        startDate: moment(values?.startDate).format("YYYY-MM-DD"),
        maximumHours: values?.maximumHours,
        comments: values?.comments,
      }
      dispatch(insertupdateNonWorkinghours(actionPayload, handleResponse))
    },
  })


  return (
    <div>
      <Form
        noValidate
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Row form>
          <Col>
            <div className="mt-3 mb-3">
              <Label htmlFor="formrow-state-Input">User Name</Label>
              <AsyncSelect
                id="userName"
                name="userName"
                styles={customStylesSelect}
                value={validation.values.userName}
                onBlur={validation.handleBlur}
                onChange={value => validation.setFieldValue("userName", value)}
                cacheOptions
                loadOptions={loadOptions}
                placeholder="Select User Name"
                defaultOptions={allUsers.map(el => ({
                  ...el,
                  label: el.username,
                  value: el.id,
                }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_one pb-1"
              />
              {validation.touched.userName && validation.errors.userName && (
                <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 1 }}>
                  {validation.errors.userName}
                </div>
              )}
            </div>

            <div className="mb-3 custom-width">
              <CustomSelectwithLabel
                id="categoryId"
                name="categoryId"
                label={props.companySetting?.MainCategory}
                onChange={value => {
                  clientFilter(value)
                  validation.setFieldValue("categoryId", value)
                }}
                value={validation.values.categoryId}
                placeholder={`Select ${props.companySetting?.MainCategory}`}
                options={[
                  { label: "All", value: "All" },
                  ...mergeMainCategory.map(el => ({
                    ...el,
                    label: el?.clientName,
                    value: el?.id,
                  })),
                ]}
              />
            </div>

            <div className="mb-3 custom-width">
              <CustomSelectwithLabel
                name="subcategoryId"
                id="subcategoryId"
                label={props.companySetting?.SubCategory}
                value={validation.values.subcategoryId}
                placeholder={`Select ${props.companySetting?.SubCategory}`}
                onBlur={validation.handleBlur}
                onChange={value =>
                  validation.setFieldValue("subcategoryId", value)
                }
                options={(mergeSubCategory || []).map(el => ({
                  ...el,
                  label: el?.projectName,
                  value: el?.id,
                }))}
              />
              {validation.touched.subcategoryId &&
                validation.errors.subcategoryId && (
                  <div
                    style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 1 }}
                  >
                    {validation.errors.subcategoryId}
                  </div>
                )}
            </div>

            <div>
              <div className="mb-3 d-flex gap-4">
                <div>
                  <Label for="startDate" className="form-label">
                    Start Date
                  </Label>
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={new Date(validation.values.startDate)}
                    onChange={value =>
                      validation.setFieldValue("startDate", value)
                    }
                    className="form-control mb-2 date-icon-back"
                    placeholderText="Select date"
                  />
                </div>
                <div>
                  <Label for="endDate" className="form-label">
                    End Date
                  </Label>
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={
                      validation.values.endDate
                        ? new Date(validation.values.endDate)
                        : null
                    }
                    onChange={value =>
                      validation.setFieldValue("endDate", value)
                    }
                    className="form-control mb-2 date-icon-back"
                    placeholderText="Select date"
                    minDate={new Date(validation.values.startDate)}
                  />
                </div>
              </div>
              {validation.touched.endDate && validation.errors.endDate && (
                <div
                  style={{
                    color: "#f46a6a",
                    fontSize: 10.4,
                    marginTop: "-17px",
                    marginBottom: "16px",
                  }}
                >
                  {validation.errors.endDate}
                </div>
              )}
            </div>

            <div className="mb-3">
              <Label for="maximumhours" className="form-label">
                Maximum Hours
              </Label>
              <InputMask
                mask="99:99:99"
                id="maximumHours"
                value={
                  taskTotalHoursConversion(validation.values.maximumHours) || ""
                }
                className={`form-control input-color ${
                  validation.touched.maximumHours &&
                  validation.errors.maximumHours
                    ? "error-border"
                    : ""
                }`}
                placeholder="Enter Time"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                autoComplete="off"
              />
              {validation.touched.maximumHours &&
                validation.errors.maximumHours && (
                  <div
                    style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}
                  >
                    {validation.errors.maximumHours}
                  </div>
                )}
            </div>

            <div className="mb-3">
              <Label for="comments" className="form-label">
                Comments
              </Label>
              <Input
                name="comments"
                id="comments"
                autoComplete="off"
                className="form-control"
                placeholder="Enter your Comments"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.comments || ""}
              />
              {validation.touched.comments && validation.errors.comments && (
                <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}>
                  {validation.errors.comments}
                </div>
              )}
            </div>
          </Col>
        </Row>
        <div className="text-end">
          <button type="submit" className="btn btn-primary save-customer me-2">
            Save
          </button>
          <button
            type="button"
            color="primary"
            className="btn btn-secondary"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </Form>
    </div>
  )
}

export default IncentiveForm
